import { useState } from 'react';
import { Send } from 'lucide-react';
import { leadsApi } from '../../services/leads.api';
import { relativeTime } from '../../lib/formatters';

export default function NoteThread({ leadId, notes: initial = [] }) {
  const [notes, setNotes] = useState(initial);
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!content.trim()) return;
    setLoading(true);
    try {
      const { data } = await leadsApi.addNote(leadId, content.trim());
      setNotes(n => [...n, data]);
      setContent('');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col gap-3">
      <div className="space-y-2 max-h-64 overflow-y-auto">
        {notes.length === 0 && <p className="text-xs text-zinc-400">No notes yet.</p>}
        {notes.map(note => (
          <div key={note.id} className="bg-zinc-50 border border-zinc-100 rounded p-2.5">
            <p className="text-sm text-zinc-800 whitespace-pre-wrap">{note.content}</p>
            <p className="text-xs text-zinc-400 mt-1">{note.author_name} · {relativeTime(note.created_at)}</p>
          </div>
        ))}
      </div>
      <form onSubmit={submit} className="flex gap-2">
        <textarea
          className="flex-1 text-sm border border-zinc-200 rounded px-2 py-1.5 resize-none focus:outline-none focus:ring-1 focus:ring-indigo-500"
          rows={2} placeholder="Add a note..." value={content}
          onChange={e => setContent(e.target.value)}
          onKeyDown={e => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); submit(e); } }}
        />
        <button type="submit" disabled={loading || !content.trim()}
          className="self-end p-2 bg-indigo-600 text-white rounded hover:bg-indigo-700 disabled:opacity-40">
          <Send size={14} />
        </button>
      </form>
    </div>
  );
}
